var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5813 15.3125V9.36875H9.5V4.34375C9.5 3.38125 9.8125 2.55 10.4375 1.85C11.0625 1.15 11.8438 0.775 12.7813 0.725001V15.3125H11.5813ZM4.4375 15.3125V8.54375C3.825 8.41875 3.3125 8.10625 2.9 7.60625C2.4875 7.10625 2.28125 6.51875 2.28125 5.84375V0.6875H3.48125V5.8625H4.4375V0.6875H5.6375V5.8625H6.59375V0.6875H7.79375V5.84375C7.79375 6.51875 7.5875 7.10625 7.175 7.60625C6.7625 8.09375 6.25 8.40625 5.6375 8.54375V15.3125H4.4375Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUnknown);
export default __webpack_public_path__ + "static/media/ico_unknown.a6b0570748ab0891e5fe97e981bfeb18.svg";
export { ForwardRef as ReactComponent };